/* eslint-disable import/no-default-export */
import {CheckoutController} from './CheckoutController';
import {controllerFactory as oldControllerFactory} from '@wix/wixstores-client-storefront-sdk';
import {ControllerConstructorType} from '../../types/types';
import {SPECS} from '../../common/constants';
import {conditionalController} from '../../domain/controllers/conditionalController';
import {controllerFactory} from './controllerFactory';

export const conditionalCheckoutControllerFactory = (controller: ControllerConstructorType<CheckoutController>) =>
  conditionalController(
    SPECS.UseNewControllerFactoryInCheckout,
    controllerFactory(controller),
    oldControllerFactory(controller, {
      shouldSkipMultilingual: true,
    })
  );

export default conditionalCheckoutControllerFactory(CheckoutController);
